import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import React from 'react';
import { useAuth } from 'react-oidc-context';
import { useParams } from 'react-router-dom';
import { useGetAllDownloadJobsQuery } from '../../features/Admin/adminDownloadJobsApiSlice';

const AdminDownloadJobDetailPage: React.FC = () => {
    const { jobId } = useParams<{ jobId: string }>();
    const auth = useAuth();
    const { data: jobs = [], isLoading, error } = useGetAllDownloadJobsQuery(auth.user?.access_token ?? '', {
        pollingInterval: 30000,
    });
    const job = jobs.find(j => j.id === jobId);

    if (isLoading) {
        return <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px"><CircularProgress /></Box>;
    }
    if (error) {
        return <Box p={3}><Typography color="error">Kunde inte ladda nedladdningsjobb.</Typography></Box>;
    }
    if (!job) {
        return <Box p={3}><Typography color="error">Nedladdningsjobb hittades inte.</Typography></Box>;
    }

    return (
        <Box p={3}>
            <Typography variant="h4" gutterBottom>Download Job Detail</Typography>
            <Paper sx={{ p: 2 }}>
                <Typography>ID: {job.id}</Typography>
                <Typography>Status: {job.state}</Typography>
                <Typography>Images: {job.imagesProcessedCount} / {job.imagesToDownloadCount}</Typography>
                <Typography>Created: {job.createdTime}</Typography>
                <Typography>Last Modified: {job.latestModifiedTime}</Typography>
                <Typography>Completed: {job.completedTime}</Typography>
                <Typography>TTL: {job.ttl}</Typography>
                {job.failureReason && <Typography color="error">Failure: {job.failureReason}</Typography>}
            </Paper>
        </Box>
    );
};

export default AdminDownloadJobDetailPage;
